const actionCreatorFactory = (type) => ({ payload, error } = {}) => ({
    type,
    ...(payload && { payload }),
    ...(error && { error }),
})

export default actionCreatorFactory
